var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tbqd twoBox"},[_c('myClock',{key:_vm.shenyu,staticClass:"lf",attrs:{"shenyu":_vm.shenyu,"cId":"c1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }